jQuery(document).ready(function() {
    jQuery('.main-menu li').click(function() {
        // Remove active class from all menu items
        jQuery('.main-menu li').removeClass('active');
        
        // Add active class to the parent li of the clicked span
        jQuery(this).addClass('active');
        
        // Get the class of the clicked span
        var select_menu = jQuery(this).find('span').attr('class');
        
        // Remove active class from all submenu items
        jQuery('.submenu li').removeClass('active');
        
        // Add active class to the matching submenu items
        jQuery('.submenu').find('.' + select_menu).addClass('active');
    });
});